import React from 'react'

interface IUser {
  group: string,
  email: string,
  firstName: string,
  lastName: string
}

export type userContext = {
  user: IUser | undefined
  setUser: (c: IUser) => void
}

export const UserContext = React.createContext<userContext>({
  user: undefined,
  setUser: () => { }
});

export const useUserContext = () => React.useContext(UserContext)
